function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { getLeafDeserializer, getToggleMarkOnKeyDown } from '@udecode/plate-common';
import { getPlatePluginOptions, getRenderLeaf } from '@udecode/plate-core';
var MARK_BOLD = 'bold';
var DEFAULTS_BOLD = {
  hotkey: 'mod+b'
};
var getBoldDeserialize = function getBoldDeserialize() {
  return function (editor) {
    var options = getPlatePluginOptions(editor, MARK_BOLD);
    return {
      leaf: getLeafDeserializer(_objectSpread({
        type: options.type,
        rules: [{
          nodeNames: ['STRONG']
        }, {
          style: {
            fontWeight: ['600', '700', 'bold']
          }
        }]
      }, options.deserialize))
    };
  };
};

/**
 * Enables support for bold formatting
 */

var createBoldPlugin = function createBoldPlugin() {
  return {
    pluginKeys: MARK_BOLD,
    renderLeaf: getRenderLeaf(MARK_BOLD),
    deserialize: getBoldDeserialize(),
    onKeyDown: getToggleMarkOnKeyDown(MARK_BOLD)
  };
};
var MARK_CODE = 'code';
var DEFAULTS_CODE = {
  hotkey: 'mod+e'
};
var getCodeDeserialize = function getCodeDeserialize() {
  return function (editor) {
    var options = getPlatePluginOptions(editor, MARK_CODE);
    return {
      leaf: getLeafDeserializer(_objectSpread({
        type: options.type,
        rules: [{
          nodeNames: ['CODE']
        }, {
          style: {
            wordWrap: 'break-word'
          }
        }]
      }, options.deserialize))
    };
  };
};

/**
 * Enables support for code formatting
 */

var createCodePlugin = function createCodePlugin() {
  return {
    pluginKeys: MARK_CODE,
    renderLeaf: getRenderLeaf(MARK_CODE),
    deserialize: getCodeDeserialize(),
    onKeyDown: getToggleMarkOnKeyDown(MARK_CODE)
  };
};
var MARK_ITALIC = 'italic';
var DEFAULTS_ITALIC = {
  hotkey: 'mod+i'
};
var getItalicDeserialize = function getItalicDeserialize() {
  return function (editor) {
    var options = getPlatePluginOptions(editor, MARK_ITALIC);
    return {
      leaf: getLeafDeserializer(_objectSpread({
        type: options.type,
        rules: [{
          nodeNames: ['EM', 'I']
        }, {
          style: {
            fontStyle: 'italic'
          }
        }]
      }, options.deserialize))
    };
  };
};

/**
 * Enables support for italic formatting.
 */

var createItalicPlugin = function createItalicPlugin() {
  return {
    pluginKeys: MARK_ITALIC,
    renderLeaf: getRenderLeaf(MARK_ITALIC),
    deserialize: getItalicDeserialize(),
    onKeyDown: getToggleMarkOnKeyDown(MARK_ITALIC)
  };
};
var MARK_STRIKETHROUGH = 'strikethrough';
var DEFAULTS_STRIKETHROUGH = {
  hotkey: 'mod+shift+s'
};
var getStrikethroughDeserialize = function getStrikethroughDeserialize() {
  return function (editor) {
    var options = getPlatePluginOptions(editor, MARK_STRIKETHROUGH);
    return {
      leaf: getLeafDeserializer(_objectSpread({
        type: options.type,
        rules: [{
          nodeNames: ['S', 'DEL', 'STRIKE']
        }, {
          style: {
            textDecoration: 'line-through'
          }
        }]
      }, options.deserialize))
    };
  };
};

/**
 * Enables support for strikethrough formatting.
 */

var createStrikethroughPlugin = function createStrikethroughPlugin() {
  return {
    pluginKeys: MARK_STRIKETHROUGH,
    renderLeaf: getRenderLeaf(MARK_STRIKETHROUGH),
    deserialize: getStrikethroughDeserialize(),
    onKeyDown: getToggleMarkOnKeyDown(MARK_STRIKETHROUGH)
  };
};
var MARK_SUBSCRIPT = 'subscript';
var DEFAULTS_SUBSCRIPT = {
  hotkey: 'mod+.',
  clear: MARK_SUBSCRIPT
};
var getSubscriptDeserialize = function getSubscriptDeserialize() {
  return function (editor) {
    var options = getPlatePluginOptions(editor, MARK_SUBSCRIPT);
    return {
      leaf: getLeafDeserializer(_objectSpread({
        type: options.type,
        rules: [{
          nodeNames: ['SUB']
        }, {
          style: {
            verticalAlign: 'sub'
          }
        }]
      }, options.deserialize))
    };
  };
};

/**
 * Enables support for subscript formatting.
 */

var createSubscriptPlugin = function createSubscriptPlugin() {
  return {
    pluginKeys: MARK_SUBSCRIPT,
    renderLeaf: getRenderLeaf(MARK_SUBSCRIPT),
    deserialize: getSubscriptDeserialize(),
    onKeyDown: getToggleMarkOnKeyDown(MARK_SUBSCRIPT)
  };
};
var MARK_SUPERSCRIPT = 'superscript';
var DEFAULTS_SUPERSCRIPT = {
  hotkey: 'mod+,',
  clear: MARK_SUPERSCRIPT
};
var getSuperscriptDeserialize = function getSuperscriptDeserialize() {
  return function (editor) {
    var options = getPlatePluginOptions(editor, MARK_SUPERSCRIPT);
    return {
      leaf: getLeafDeserializer(_objectSpread({
        type: options.type,
        rules: [{
          nodeNames: ['SUP']
        }, {
          style: {
            verticalAlign: 'super'
          }
        }]
      }, options.deserialize))
    };
  };
};

/**
 * Enables support for superscript formatting.
 */

var createSuperscriptPlugin = function createSuperscriptPlugin() {
  return {
    pluginKeys: MARK_SUPERSCRIPT,
    renderLeaf: getRenderLeaf(MARK_SUPERSCRIPT),
    deserialize: getSuperscriptDeserialize(),
    onKeyDown: getToggleMarkOnKeyDown(MARK_SUPERSCRIPT)
  };
};
var MARK_UNDERLINE = 'underline';
var DEFAULTS_UNDERLINE = {
  hotkey: 'mod+u'
};
var getUnderlineDeserialize = function getUnderlineDeserialize() {
  return function (editor) {
    var options = getPlatePluginOptions(editor, MARK_UNDERLINE);
    return {
      leaf: getLeafDeserializer(_objectSpread({
        type: options.type,
        rules: [{
          nodeNames: ['U']
        }, {
          style: {
            textDecoration: 'underline'
          }
        }]
      }, options.deserialize))
    };
  };
};

/**
 * Enables support for underline formatting.
 */

var createUnderlinePlugin = function createUnderlinePlugin() {
  return {
    pluginKeys: MARK_UNDERLINE,
    renderLeaf: getRenderLeaf(MARK_UNDERLINE),
    deserialize: getUnderlineDeserialize(),
    onKeyDown: getToggleMarkOnKeyDown(MARK_UNDERLINE)
  };
};

/**
 * Enables support for basic marks:
 * - Bold
 * - Code
 * - Italic
 * - Strikethrough
 * - Subscript
 * - Superscript
 * - Underline
 */

var createBasicMarkPlugins = function createBasicMarkPlugins() {
  return [createBoldPlugin(), createCodePlugin(), createItalicPlugin(), createStrikethroughPlugin(), createSubscriptPlugin(), createSuperscriptPlugin(), createUnderlinePlugin()];
};
export { DEFAULTS_BOLD, DEFAULTS_CODE, DEFAULTS_ITALIC, DEFAULTS_STRIKETHROUGH, DEFAULTS_SUBSCRIPT, DEFAULTS_SUPERSCRIPT, DEFAULTS_UNDERLINE, MARK_BOLD, MARK_CODE, MARK_ITALIC, MARK_STRIKETHROUGH, MARK_SUBSCRIPT, MARK_SUPERSCRIPT, MARK_UNDERLINE, createBasicMarkPlugins, createBoldPlugin, createCodePlugin, createItalicPlugin, createStrikethroughPlugin, createSubscriptPlugin, createSuperscriptPlugin, createUnderlinePlugin, getBoldDeserialize, getCodeDeserialize, getItalicDeserialize, getStrikethroughDeserialize, getSubscriptDeserialize, getSuperscriptDeserialize, getUnderlineDeserialize };